angular.module('picmonicng').component('homeMyExperiencePoints', {
  templateUrl: '/templates/app/components/home-my-experience-points/home-my-experience-points.html',
  bindings: {
    settings: '=',
  },
  controller: [
    '$rootScope',
    '$scope',
    '$modal',
    'User',
    'UserService',
    function ($rootScope, $scope, $modal, User, UserService) {
      var ctrl = this;
      $scope.UserService = UserService;
      $scope.min = Math.min;

      // Achievements data
      $scope.achievements = User.queryv3({ resource: 'achievements' });

      const now = moment();
      const weekdays = moment.weekdays();
      const timezone = UserService.user.settings.timezone || moment.tz.guess();

      const timeDiff = moment(now).tz(timezone).endOf('day') - now;

      $scope.hoursLeft = moment.duration(timeDiff).hours() + 4;

      $scope.xps = User.queryv3({
        resource: 'xp',
      });

      $scope.xps.$promise.then(function () {
        $scope.xp = $scope.xps[6].xp;

        // 1 week ago to today
        const xps = _.compact(
          _.map($scope.xps, (xp, index) => {
            const xpDate = moment().subtract(xp.date, 'days');

            if (xpDate.isSameOrAfter(moment().day('Sunday'))) {
              return {
                day: xpDate.day(),
                xp: xp.xp,
                streak_freeze: xp.streak_freeze,
              };
            }
          })
        );

        $scope.weekdaysData = _.map(weekdays, (weekday, index) => {
          return {
            label: weekday.substring(0, 1),
            past: index < now.day(),
            present: index === now.day(),
            future: index > now.day(),
            completed: xps[index] && xps[index].xp >= UserService.user.settings.daily_goal,
            freeze: xps[index] && xps[index].streak_freeze,
          };
        });

        // XP History chart
        var labels = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];
        var day = new Date().getDay();
        $scope.labels = labels.concat(labels.splice(0, (day + 1) % 7));

        $scope.options = {
          scales: {
            y: {
              min: 0,
              ticks: {
                color: '#FFFFFF',
                precision: 0,
                beginAtZero: true,
                stepSize: 5,
              },
              title: {
                align: 'center',
                display: true,
                text: 'My XP',
                color: '#F9F9F9',
                font: {
                  family: 'Raleway',
                  size: 12,
                  style: 'normal',
                  weight: 'normal',
                  lineHeight: '20px',
                },
              },
            },
            x: {
              ticks: {
                color: '#FFFFFF',
                font: {
                  weight: function (value, index) {
                    if (value.index === 6) {
                      return 'bold';
                    }
                  },
                },
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              displayColors: false,
              callbacks: {
                title: function (tooltipItem) {
                  switch (tooltipItem[0].label) {
                    case 'Su':
                      return 'Sunday';
                    case 'M':
                      return 'Monday';
                    case 'Tu':
                      return 'Tuesday';
                    case 'W':
                      return 'Wednesday';
                    case 'Th':
                      return 'Thursday';
                    case 'F':
                      return 'Friday';
                    case 'Sa':
                      return 'Saturday';
                  }

                  return tooltipItem[0].label;
                },
                label: function (context) {
                  return (context.parsed.y ? context.parsed.y : '0') + ' XP';
                },
              },
            },
            title: {
              display: true,
              text: 'XP History',
              color: '#F9F9F9',
              font: {
                family: 'Raleway',
                size: 12,
                style: 'normal',
                weight: 'normal',
                lineHeight: '20px',
              },
            },
          },
        };

        $scope.data = {
          labels: $scope.labels,
          datasets: [
            {
              data: $scope.xps.map(function (x) {
                return x.xp;
              }),
              backgroundColor: 'rgba(255, 150, 0, 0.2)',
              pointBackgroundColor: 'rgba(255, 150, 0, 1)',
              pointHoverBackgroundColor: 'rgba(255, 150, 0, 0.8)',
              borderColor: 'rgba(255, 150, 0, 1)',
              pointBorderColor: '#fff',
              pointHoverBorderColor: 'rgba(255, 150, 0, 1)',
              tension: 0.5,
              fill: 'origin',
            },
          ],
        };

        const config = {
          type: 'line',
          data: $scope.data,
          options: $scope.options,
        };

        new Chart(document.getElementById('xp-graph'), config);
      });

      $rootScope.$on('xp', function (evt, data) {
        $scope.xp = $scope.xp + data.amount;
      });

      // Daily XP goal data
      $scope.openSettings = function () {
        $modal.open({
          templateUrl: '/templates/modals/daily-goal-settings.html',
          windowClass: 'daily-goal-settings-modal',
          backdropClass: 'above-nav',
          size: 'sm',
          controller: [
            '$scope',
            function ($scope) {
              $scope.goal = UserService.user.settings.daily_goal || 10;
              $scope.select = function (goal) {
                $scope.goal = goal;
              };

              $scope.save = function () {
                if (typeof atlasEvent !== 'undefined') {
                  atlasEvent('click', 'Daily Goal Changed ' + $scope.goal);
                }
                UserService.user.settings.daily_goal = $scope.goal;
                UserService.user.$update().then(function () {
                  $scope.$close();
                });
              };
            },
          ],
        });
      };

      // League data
      $scope.league = User.getv3({ resource: 'league' });
      $scope.getTimeRemaining = function () {
        var exp = $scope.league.expires_at - Math.floor(Date.now() / 1000);
        var time = Math.floor(exp / 86400) + 'D ';
        time += Math.floor((exp % 86400) / 3600) + 'H ';
        time += Math.floor((exp % 3600) / 60) + 'M';
        return time;
      };
    },
  ],
});
